export default () => (
    <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="ellipsis-v"
    class="fxs_icon svg-inline--fa fa-ellipsis-v fa-w-2"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 512"
>
    <path
        fill="currentColor"
        d="M32 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 136c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm0 240c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32z"
    ></path>
</svg>
);
